module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto p-interest__calc"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Interest Calculator",
      "icon": "interest"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_from",
      "label": "Date From"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_from.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_from",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateFrom",
    on: {
      "input": function($event) {
        return _vm.updateTotal()
      }
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_from')
    }
  }, [_vm._v("\n                    The date from is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_to",
      "label": "Date To"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_to.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_to",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateTo",
    on: {
      "input": function($event) {
        return _vm.updateTotal()
      }
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_to') || !_vm.dateRules
    }
  }, [_vm._v("\n                    The date to is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "interest_rate",
      "label": "Interest Rate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.interestRate),
      expression: "interestRate",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "interestRate",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "name": "interest_rate",
      "type": "number"
    },
    domProps: {
      "value": (_vm.interestRate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.interestRate = _vm._n($event.target.value)
      }, function($event) {
        return _vm.updateTotal()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('interest_rate')
    }
  }, [_vm._v("\n                    The Interest Rate must be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "principal_amount",
      "label": "Principal Amount",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.principalAmount),
      expression: "principalAmount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "principalAmount",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.principalAmount)
    },
    on: {
      "focus": function($event) {
        _vm.principalAmount = _vm.principalAmount || ''
      },
      "blur": [function($event) {
        _vm.principalAmount = _vm.principalAmount || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.principalAmount = _vm._n($event.target.value)
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('principal_amount')
    }
  }, [_vm._v("\n                    The Amount must be greater than £0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "interest_type",
      "label": "Interest Type"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    ref: "interestType",
    attrs: {
      "required": "",
      "name": "interest_type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "compound"
    }
  }, [_vm._v("Compound")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('interest_type')
    }
  }, [_vm._v("\n                    Please select an Interest Type\n                ")])], 1), _vm._v(" "), (_vm.interestType === 'compound') ? _c('control', {
    attrs: {
      "for": "compound_frequency",
      "label": "Compound Frequency"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.compoundFrequency),
      expression: "compoundFrequency"
    }],
    ref: "compoundFrequency",
    attrs: {
      "required": "",
      "name": "compound_frequency"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compoundFrequency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "52"
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Monthly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Quarterly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Yearly")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('compound_frequency')
    }
  }, [_vm._v("\n                    Please select a Compound Frequency\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Results\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "interest_accrued",
      "label": "Interest Accrued",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.interestAccrued),
      expression: "interestAccrued",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "name": "interest_accrued"
    },
    domProps: {
      "value": (_vm.interestAccrued)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interestAccrued = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "theTotal",
      "label": "Total",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.theTotal),
      expression: "theTotal",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "name": "theTotal"
    },
    domProps: {
      "value": (_vm.theTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.theTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The accrued interest between the period of "), _c('strong', [_vm._v(_vm._s(_vm.dateFrom))]), _vm._v(" and "), _c('strong', [_vm._v(_vm._s(_vm.dateTo))]), _vm._v("\n                on the principal of "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.principalAmount)))]), _vm._v(", with an interest rate of\n                "), _c('strong', [_vm._v(_vm._s(_vm.interestRate) + "%")]), _vm._v(",\n                using\n                "), (_vm.interestType === 'compound') ? _c('span', [_vm._v("the "), _c('strong', [_vm._v("compound")]), _vm._v(" interest calculation with\n                    compounding occurring "), _c('strong', [_vm._v(_vm._s(_vm.frequency))])]) : _c('span', [_vm._v("the "), _c('strong', [_vm._v("simple")]), _vm._v(" interest calculation")]), _vm._v("\n                is calculated using the following formula:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [(_vm.interestType === 'compound') ? _c('span', [_vm._v("\n                            [£ Total] = [£ Principal (1 + [Interest Rate %]/[Periods])[Periods] * [Duration]\n                        ")]) : _c('span', [_vm._v("\n                            [£ Total] = [£ Principal] x [1 + Interest Rate %] x [Duration]\n                        ")])])])]), _vm._v(" "), (_vm.interestType === 'compound') ? _c('p', [_vm._v("\n                Where "), _c('strong', [_vm._v("duration")]), _vm._v(" is the accrual length in years and "), _c('strong', [_vm._v("periods")]), _vm._v(" is the\n                number of\n                compounding periods that occur each year (e.g., compounding quarterly results in 4 periods per\n                year).\n            ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                This results in "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestAccrued)))]), _vm._v(" of interest having been\n                accrued,\n                resulting in a total figure of "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.theTotal)))]), _vm._v(". This has been\n                displayed\n                on the following graph for you:\n            ")]), _vm._v(" "), (_vm.theTotal) ? _c('div', {
    staticClass: "chart chart--bar"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-interest__calc-results-group"
  }, [_c('div', [_vm._v("Aggregate Rate: "), _c('span', [_vm._v(_vm._s(_vm.roundValue(_vm.aggregateRate / 100, 2)) + "%")])]), _vm._v(" "), _c('div', [_vm._v("Number of Days: "), _c('span', [_vm._v(_vm._s(_vm.noOfDays))])]), _vm._v(" "), _c('div', [_vm._v("Interest per day: "), _c('span', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dailyRate)))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bdd9a7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/Interest.vue
// module id = 1596
// module chunks = 0